import React from 'react';

export const ImageContent = ({ formBlock }) => {
	return <div>{formBlock.image() && <img src={formBlock.image()} alt="" />}</div>;
};
